import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './AdminNavBarstyle.css';
import supabase from '../utils/supabaseClient';

function AdminNavBar({ user }) {
  const navigate = useNavigate();
  
  if (!user) return null;
  
  return (
    <nav className="admin-navbar">
      <Link to="/edit-producto" className="admin-navbar-link">Productos</Link>
      <Link to="/edit-subfamilia" className="admin-navbar-link">Subfamilias</Link>
      <Link to="/edit-familia" className="admin-navbar-link">Familias</Link>
      <Link to="/upload-banners" className="admin-navbar-link">Banners</Link>
      
      <button
        onClick={async () => {
          await supabase.auth.signOut();
          navigate('/'); // Use navigate instead of window.location
        }}
        className="admin-navbar-button"
      >
        Cerrar sesión
      </button>
    </nav>
  );
}

export default AdminNavBar;